// Lightweight theme helper for L⚡t‑ning design (UI-only)
// - Persists choice in localStorage
// - Prefers system color scheme on first load
// - Applies data-theme on <html> (documentElement) for broad CSS support

const THEME_KEY = 'lytTheme';

export function getPreferredTheme() {
  // Prefer explicit user choice; default to light on first run for consistent UX
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (_) { /* ignore */ }
  return 'light';
}

export function applyTheme(theme) {
  const root = document.documentElement; // <html>
  if (!root) return;
  root.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
}

export function toggleTheme() {
  const root = document.documentElement; // <html>
  const current = root?.getAttribute('data-theme') || 'light';
  const next = current === 'dark' ? 'light' : 'dark';
  try { localStorage.setItem(THEME_KEY, next); } catch (_) { /* ignore */ }
  applyTheme(next);
  try { window.dispatchEvent(new CustomEvent('theme:changed', { detail: { theme: next } })); } catch (_) { /* ignore */ }
  return next;
}

export function initTheme() {
  const theme = getPreferredTheme();
  applyTheme(theme);
  return theme;
}
